module.exports = "<div class=\"navigation\">\r\n    <h2 class=\"sr-only\">My Account Navigation</h2>\r\n    <nav role=\"navigation\" class=\"navigation-items\">\r\n        <a id=\"accessibilityLink\" ui-sref=\"shop.support.accessibility\" ui-sref-active=\"is-active\" class=\"navigation-link\">\r\n            Accessibility\r\n        </a>\r\n    </nav>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/accessibility/accessibility-nav-links.directive.html
// module id = 108
// module chunks = 0 2